/**
 * Do not edit directly
 * Generated on Tue, 19 Mar 2024 13:54:31 GMT
 */

module.exports = {
  "radiusBase": "8px",
  "radiusCircle": "50%",
  "radiusModal": "8px",
  "radiusPill": "100px",
  "widthBase": "1px"
};